import * as angular from 'angular';
import { ITask, TasksService } from '../../services/tasks.service';
import { AuthUserService } from '../../authsettings/services/authusers.service';

class TaskItemController {
    private task: ITask;
    private tasksService: any;
    private userService: any;
    private isArchive: boolean;

    constructor(
        TasksService: TasksService,
        AuthUserService: AuthUserService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private SweetAlert: any
    ) {
        'ngInject';
        this.tasksService = TasksService;
        this.userService = AuthUserService;
    }

    public $onInit = () => {
        if (this.$stateParams['isArchive']) {
            this.isArchive = true;
        }
    }

    submitTask() {
        if (this.task.id == null) {
            this.saveTask();
        } else {
            this.tasksService.put(this.task.id, this.task);
        }
    }

    saveTask() {
        this.tasksService.post(this.task).then(result => {
            this.$state.go('hr.tasks.item', { 'id': result.id });
        });
    }

    deleteTask() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze medewerker wilt verwijderen?\n Diensten en declaraties van de medewerker blijven onveranderd!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.tasksService.delete(this.task.id);
                this.$state.go('^.list').then(() => { this.$state.reload(); });
            } else {

            }
        });
    }
}

export const taskItemComponent = {
    bindings: {
        task: '<',
    },
    controller: TaskItemController,
    template: require('./task.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/tasks/task.item.component.ts